import { GET_GROUP, GET_GROUPS, CLEAR_GROUPS, GET_MY_GROUPS, GET_SCHOOL_GROUPS, GET_FILTERED_GROUPS_REQUEST, GET_FILTERED_GROUPS_SUCCESS, GET_FILTERED_GROUPS_FAILURE, CLEAR_GROUP_ID, CLEAR_GROUP_BY_GRAPHID, CLEAR_MY_GROUPS, CLEAR_SCHOOL_GROUPS, CLEAR_FILTERED_GROUPS } from 'actions/groups';
import moment from 'moment';

const INITIAL_STATE = {
	groups: {},
	filteredGroups: [],
	lastFetchedGroups: null,
	lastFetchedSchoolGroups: null,
};

/**
 * 
 * @param {Object} groups Keyed object of groups
 * @param {number} groupId 
 * @returns 
 */
const removeGroup = (groups, groupId) => {
	const { [groupId]: removed, ...remainingGroups } = groups;
	return remainingGroups;
};

const processGroups = (groups, existingGroups) => {
	return groups.reduce((acc, group) => {
		if (!existingGroups || !existingGroups[group.id]) {
			acc[group.id] = {
				...group,
				lastFetched: moment.utc(moment.now()),
				userRole: !group.userRole || (typeof group.userRole === 'string' && group.userRole.trim() === '')
					? ''
					: group.userRole.toUpperCase(),
			};
		}
		return acc;
	}, {});
}

/**
 * Sorts two objects by their lastName, case-insensitive.
 * 
 * @param {Object} a - First object with lastName.
 * @param {Object} b - Second object with lastName.
 * @returns {number} - Comparison result for Array.sort().
 */
const sortByLastName = (a, b) => {
	const nameA = (a.lastName || '').toLowerCase();
	const nameB = (b.lastName || '').toLowerCase();
	return nameA.localeCompare(nameB);
};

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case GET_GROUPS:
		case GET_SCHOOL_GROUPS:
			if (action.payload != null) {
				const newGroups = processGroups(action.payload, state.groups);

				const updatedState = {
					...state,
					groups: { ...state.groups, ...newGroups },
				};

				if (action.type === GET_GROUPS) {
					updatedState.lastFetchedGroups = moment.utc(moment.now());
				} else if (action.type === GET_SCHOOL_GROUPS) {
					updatedState.lastFetchedSchoolGroups = moment.utc(moment.now());
				}

				return updatedState;
			}
			return { ...state, loading: false };
		case GET_GROUP:
			if (action.payload != null) {
				const groupDetails = action.payload;

				if (groupDetails.courses != null && groupDetails.courses.length > 0) {
					groupDetails.courses.forEach((element) => {
						if (element.details != null && element.details.length > 0) {
							var activeDetailIndex = element.details.findIndex(
								(element) => element.endDate == null
							);

							if (activeDetailIndex > -1) {
								var activeDetail = element.details[activeDetailIndex];
								element.details.splice(activeDetailIndex, 1);
								element.details.unshift(activeDetail);
							}
						}
					});
				}

				const updatedGroup = groupDetails.group;
				const expandParams = groupDetails.expandParams;

				let existingGroup = state.groups[updatedGroup.id] || null;

				if (existingGroup === null) {
					// If the group doesn't already exist, add the updatedGroup as is
					existingGroup = { ...updatedGroup };
				} else if (expandParams != null && expandParams.length > 0) {
					// For each attribute key we expect to update (from expandParams)
					expandParams.forEach((key) => {
						let normalizedKey = key.toLowerCase();

						// Normalize the keys of updatedGroup for case-insensitive comparison
						const normalizedUpdatedGroup = Object.keys(updatedGroup).reduce((acc, k) => {
							acc[k.toLowerCase()] = k; // Store the original key reference
							return acc;
						}, {});

						// Check if the normalized key exists in updatedGroup (case-insensitive)
						if (normalizedUpdatedGroup[normalizedKey]) {
							let originalKey = normalizedUpdatedGroup[normalizedKey]; // Get original casing
							existingGroup[originalKey] = updatedGroup[originalKey];
						}
					});
				}

				if (existingGroup != null && existingGroup.id > 0) {
					existingGroup.userRole = !existingGroup.userRole || (typeof existingGroup.userRole === 'string' && existingGroup.userRole.trim() === '') ? '' : existingGroup.userRole.toUpperCase();
					existingGroup.lastFetched = moment.utc(moment.now());

					existingGroup.members = Array.isArray(existingGroup.members) ? existingGroup.members.sort(sortByLastName) : existingGroup.members;


					existingGroup.owners = Array.isArray(existingGroup.owners) ? existingGroup.owners.sort(sortByLastName) : existingGroup.owners;
				}

				return {
					...state,
					groups: {
						...state.groups,
						[updatedGroup.id]: existingGroup
					}
				};
			}

			return { ...state };
		case GET_FILTERED_GROUPS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};

		case GET_FILTERED_GROUPS_SUCCESS:
			return {
				...state,
				loading: false,
				filteredGroups: action.payload,
			};

		case GET_FILTERED_GROUPS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case CLEAR_GROUP_BY_GRAPHID: {
			const graphId = action.payload;
			const existingGroupByGraphId = Object.values(state.groups).find(g => g.graphId === graphId);

			if (existingGroupByGraphId == null) return state;
			const updatedGroups = removeGroup(state.groups, existingGroupByGraphId.id);

			return {
				...state,
				groups: updatedGroups,
			}
		}
		case CLEAR_GROUP_ID: {
			const groupId = action.payload;
			const existingGroup = state.groups[groupId];

			if (existingGroup == null) return state;
			const updatedGroups = removeGroup(state.groups, existingGroup.id);

			return {
				...state,
				groups: updatedGroups,
			};
		}
		case CLEAR_GROUPS:
			return {
				...state,
				groups: {},
				lastFetchedGroups: null,
			};
		case CLEAR_FILTERED_GROUPS:
			return {
				...state,
				filteredGroups: [],
			};
		case CLEAR_SCHOOL_GROUPS:
			return {
				...state,
				groups: {},
				lastFetchedSchoolGroups: null,
			};
		default:
			return state;
	}
}